import { useFormik } from "formik";
import React, { useRef, useState } from "react";
import { Calendar } from "rsuite";
import { DateRangePicker, DatePicker } from "rsuite";
import { revenueReport } from "../../../services/tableOrder.service";
import { capitalizeFirstLetter, formateDateWithMonthForGraph, getDateInFormat, showPrice, TrimText, writeMyExcel } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import CustomError from "../../../../../utils/customError";

function DownloadReport() {
  const { t } = useTranslation();

  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  // Define your locale mapping for different languages
  const localeMap = {
    en: "en-US",
    hi: "hi-IN",
    ja: "ja-JP",
    ne: "hi-IN",
    th: "th-TH",
    zh: "zh-CN",
  };

  const locale = localeMap[currentLang] || "en-US";

  const containerRef = useRef(null);

  const customContainer = () => {
    return document.getElementById("custom-container");
  };

  const revenueReportForm = useFormik({
    initialValues: { created: [], type: "sales" },
    enableReinitialize: true,
    validationSchema: Yup.object({
      type: Yup.string().trim().required("type_required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("created", values.created);
      formData.append("type", values.type);
      revenueReport(formData)
        .then((response) => {
          // console.log(response.data);
          if (values.type === "sales") {
            handleSalesExportToExcel(response?.data?.dailyData || [], response?.data?.totalValues || []);
          } else {
            handleExportToExcel(response?.data?.transactions ? response?.data?.transactions : []);
          }
          // resetForm();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  });

  const handleDateChange = (value) => {
    revenueReportForm.setFieldValue("created", value);
  };

  const handleSalesExportToExcel = (reportData = [], totalData = []) => {
    // Prepare the data for export
    const headers = [
      "Date",
      "Total Transactions",
      "Total Sales",
      "Total Cost Price",
      "Total Profit",
      "Profit Rate (%)",
      "Total Cash",
      "Total Online Payment"
    ];

    const rows = reportData.map((item) => [
      formateDateWithMonthForGraph(item?.date),
      item?.totalTransactions,
      `	£${showPrice(item?.totalSales)}`,
      `	£${showPrice(item?.totalCostPrice)}`,
      `	£${showPrice(item?.totalProfit)}`,
      item.profitRate ? `${item.profitRate.toFixed(0)}%` : "0%",
      `	£${showPrice(item?.totalCash)}`,
      `	£${showPrice(item?.totalCredit)}`

    ]);

    // Add total row at the end
    if (totalData) {
      rows.push([
        "Total",
        totalData?.totalTransactions,
        `£${showPrice(totalData?.totalSales)}`,
        `£${showPrice(totalData?.totalCostPrice)}`,
        `£${showPrice(totalData?.totalProfit)}`,
        totalData.profitRate ? `${totalData.profitRate.toFixed(0)}%` : "0%",
        `£${showPrice(totalData?.totalCash)}`,
        `£${showPrice(totalData?.totalCredit)}`
      ]);
    }

    writeMyExcel([headers, ...rows], `${t('label_daily_base_report')}.xlsx`);
  };

  const handleExportToExcel = (data) => {
    // Prepare the data for export
    const headers = [
      "Date & Time",
      "Transaction No",
      "Table No",
      "Amount",
      "Payment Method",
      "Split Count",
      "Comments",
    ];

    const rows = data.map((item) => [
      getDateInFormat(item?.createdAt),
      String(item?.transactionNumber || "-"),
      capitalizeFirstLetter(item?.table_number) || "-",
      `£${showPrice(item?.grand_total || 0, 2)}`,
      capitalizeFirstLetter(item?.payment_method),
      item?.split_count || 0,
      item?.comment && item.comment.length > 0
        ? TrimText(capitalizeFirstLetter(item.comment), 10)
        : "Success",
    ]);

    writeMyExcel([headers, ...rows], `${t('label_transaction_history_report')}.xlsx`);
  };




  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">Download Report</h4>
        </div>
        <div className="card-outer-header d-flex justify-content-between align-items-center mb-4">
          <div className="card">
            <div className="card-body">
              <form onSubmit={revenueReportForm.handleSubmit}>
                <div className="calendar-box d-flex ">
                  <DateRangePicker
                    open={true}
                    showHeader={false}
                    locale={{
                      sunday: t("SUN"),
                      monday: t("MON"),
                      tuesday: t("TUE"),
                      wednesday: t("WED"),
                      thursday: t("THU"),
                      friday: t("FRI"),
                      saturday: t("SAT"),
                      monthFormat: "MMMM yyyy",
                    }}
                    ranges={[]}
                    style={{
                      visibility: "hidden",
                      position: "absolute",
                      margin: "0 20px",
                      width: "500px",
                    }}
                    cleanable={false}
                    editable={false}
                    disabledDate={(date) => date > new Date()}
                    defaultCalendarValue={[new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date()]}
                    container={() => containerRef.current}
                    // onChange={(value) => {
                    //   console.log("changed" , value);
                    //   handleDateChange(value)
                    // }}
                    onChange={handleDateChange}
                    // renderTitle={(date) => {
                    //   return <span>{date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</span>;
                    // }}
                    renderTitle={(date) => {
                      return <span>{date.toLocaleDateString(locale, { month: "long", year: "numeric" })}</span>;
                    }}

                  />

                  <div id="custom-container" ref={containerRef}></div>
                </div>
                <div className="radio-btns-list d-flex flex-column gap-3 py-3">
                  <div className="form-check">
                    <input
                      className="form-check-input cp"
                      type="radio"
                      id="sales"
                      value="sales"
                      name="type"
                      checked={revenueReportForm.values.type === "sales"}
                      onChange={revenueReportForm.handleChange}
                      onBlur={revenueReportForm.handleBlur}
                    />
                    <label className="form-check-label cp" htmlFor="sales">
                      Daily Sales Basis
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input cp"
                      type="radio"
                      id="transaction"
                      value="transaction"
                      name="type"
                      checked={revenueReportForm.values.type === "transaction"}
                      onChange={revenueReportForm.handleChange}
                      onBlur={revenueReportForm.handleBlur}
                    />
                    <label className="form-check-label cp" htmlFor="transaction">
                      Each Transaction Basis
                    </label>
                  </div>
                  <CustomError className="mx-2 text-danger" name="type" form={revenueReportForm} />
                  <div>
                    <button className="btn btn-primary" type="submit">
                      Export
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default DownloadReport;
